export const UPDATE_SYNTHETIC_COLOR_KEY = 'UPDATE_SYNTHETIC_COLOR_KEY'
export const UPDATE_COLOR_VALUE = 'UPDATE_COLOR_VALUE'
export const UPDATE_COLOR = 'UPDATE_COLOR'
export const CREATE_COLOR = 'CREATE_COLOR'
export const DELETE_COLOR = 'DELETE_COLOR'
export const ADD_NEW_COLOR = 'ADD_NEW_COLOR'
export const ADD_COLOR_ROW = 'ADD_COLOR_ROW'

export const supportedColorKeys = [
  'primary_color',
  'secondary_color',
  'separator_color',
  'footer_background_color',
  'body_background_color',
  'email_background_color',
  'text_color',
  'footer_link_color',
  'rasa_brand_text_color',
  'title_color',
  'source_text_color',
  'footer_text_color',
  'configurable_footer_background_color',
  'configurable_footer_text_color',
]



// WEBPACK FOOTER //
// ./src/pages/newsbrief/color-picker/constants.ts